(() => {
  const section = document.querySelector('[data-bcos-subscriptions], [data-bcos-purchase-options]');
  if (!section) return;

  const purchaseOptions = document.querySelector('[data-bcos-purchase-options]');
  const root = window.Shopify?.routes?.root || '/';

  function track(name, data) {
    if (window.BcosAnalytics && typeof window.BcosAnalytics.track === 'function') {
      window.BcosAnalytics.track(name, data || {}, 'analytics');
    }
  }

  function formatMoney(cents) {
    return window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents, window.Shopify?.moneyFormat)
      : new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        }).format((cents || 0) / 100);
  }

  /* ---------------------------------------------------------- */
  /* Purchase options (Buy Box integration)                      */
  /* ---------------------------------------------------------- */
  if (purchaseOptions) {
    const radios = [...purchaseOptions.querySelectorAll('[data-purchase-option]')];
    const panel = purchaseOptions.querySelector('[data-selling-plan-panel]');
    const planSelect = purchaseOptions.querySelector('[data-selling-plan-select]');
    const badge = purchaseOptions.querySelector('[data-subscription-badge]');
    const oneTimePrice = purchaseOptions.querySelector('[data-one-time-price]');
    const subPrice = purchaseOptions.querySelector('[data-subscription-price]');

    let basePrice = parseInt(purchaseOptions.dataset.basePrice || '0', 10);
    let compareAtPrice = parseInt(purchaseOptions.dataset.compareAtPrice || '0', 10);

    function currentPlan() {
      const option = planSelect?.selectedOptions?.[0];
      if (!option) return null;
      return {
        id: option.value,
        name: option.textContent.trim(),
        type: option.dataset.adjustmentType || 'percentage',
        value: parseFloat(option.dataset.adjustmentValue || '0'),
      };
    }

    function planPrice(base, plan) {
      if (!plan) return base;
      if (plan.type === 'percentage') return Math.round(base * (1 - plan.value / 100));
      if (plan.type === 'fixed_amount') return Math.max(0, Math.round(base + plan.value * 100));
      if (plan.type === 'price') return Math.round(plan.value);
      return base;
    }

    function savingsLabel(base, planPrice) {
      const saved = base - planPrice;
      if (saved <= 0) return '';
      const pct = base > 0 ? Math.round((saved / base) * 100) : 0;
      return pct > 0 ? `Save ${pct}%` : `Save ${formatMoney(saved)}`;
    }

    function isSubscription() {
      const checked = radios.find((radio) => radio.checked);
      return checked?.value === 'subscription';
    }

    function updateUI() {
      const sub = isSubscription();
      if (panel) panel.hidden = !sub;

      if (oneTimePrice) oneTimePrice.textContent = formatMoney(basePrice);

      const plan = currentPlan();
      if (subPrice) {
        const price = plan ? planPrice(basePrice, plan) : basePrice;
        subPrice.textContent = plan ? `${formatMoney(price)} / ${plan.name}` : formatMoney(basePrice);
      }
      if (badge) {
        const label = plan ? savingsLabel(basePrice, planPrice(basePrice, plan)) : '';
        badge.hidden = !label;
        badge.textContent = label;
      }
      if (planSelect) planSelect.disabled = !sub;
    }

    function setVariant(price, compareAt) {
      basePrice = price;
      if (typeof compareAt === 'number') compareAtPrice = compareAt;
      updateUI();
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        updateUI();
        if (radio.value === 'subscription') {
          track('subscription_selected', { selling_plan: currentPlan()?.id });
        }
      });
    });

    planSelect?.addEventListener('change', () => {
      updateUI();
      track('selling_plan_changed', { selling_plan: currentPlan()?.id });
    });

    const productForm = purchaseOptions.closest('form[data-bcos-add-to-cart]');
    productForm?.addEventListener('submit', () => {
      if (isSubscription() && planSelect) {
        track('subscription_added_to_cart', {
          selling_plan: planSelect.value,
          quantity: parseInt(productForm.querySelector('[data-quantity-hidden], [name="quantity"]')?.value || '1', 10),
        });
      }
    });

    document.addEventListener('bcos:variant:changed', (event) => {
      const detail = event.detail || {};
      if (detail.price) setVariant(detail.price, detail.compareAtPrice);
    });

    updateUI();
    track('subscription_option_viewed', { has_selling_plans: true });
  }

  /* ---------------------------------------------------------- */
  /* Membership / dashboard interactions                         */
  /* ---------------------------------------------------------- */
  section.querySelectorAll('[data-membership-cta]').forEach((cta) => {
    cta.addEventListener('click', () => {
      track('membership_cta_clicked', { tier: cta.dataset.tier || '', url: cta.getAttribute('href') || '' });
    });
  });

  const dashboard = section.querySelector('[data-subscription-dashboard]');
  dashboard?.addEventListener('click', () => {
    track('membership_dashboard_opened', { has_subscriptions: dashboard.dataset.hasSubscriptions === 'true' });
  });

  const education = section.querySelector('[data-subscription-education]');
  education?.addEventListener('toggle', (event) => {
    if (event.target.open) {
      track('subscription_education_opened', {
        question: event.target.querySelector('summary span')?.textContent?.trim() || '',
      });
    }
  });

  window.BcosSubscriptions = window.BcosSubscriptions || { setVariant };
  if (purchaseOptions) window.BcosSubscriptions.setVariant = setVariant;
})();
